// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 10) return "static/js/60bbb2412242a0c2f9b0.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"f47241affcb708a4ee42","145":"bd0a38c75602378cc13c","146":"7ddf5920f847eafa7164"}[chunkId] + ".chunk.js";
};